import * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * Animated placeholder used while a page waits for SWR data to resolve.
 * Pages should hold the same overall layout (header + section frames) and
 * swap rendered rows for `<Skeleton />` blocks so the layout doesn't reflow
 * when data lands. Width / height are controlled by Tailwind classes on the
 * consumer side — see e.g. `pages/orders/index.jsx` for the typical row
 * shape.
 */
const Skeleton = React.forwardRef(({ className, ...props }, ref) => (
	<div ref={ref} className={cn('animate-pulse rounded-md bg-muted', className)} aria-hidden="true" {...props} />
));
Skeleton.displayName = 'Skeleton';

export { Skeleton };
